/** The tabs of the Filings place: one per regime the product has loaded (ADR-0212 decision 6). */

import type { Obligation } from "../../api/queries";
import type { Regime } from "../../api/regimes";
import { isOwed } from "../reportsModel";

interface RegimeTab {
  key: string;
  label: string;
}

/** The regimes to draw a tab for: every loaded regime, owed ones first, then by name. A regime the
 * regimes read did not return but a filing names is still drawn (a filing must be reachable). */
export function regimeTabs(regimes: readonly Regime[] | undefined, filings: readonly Obligation[]): RegimeTab[] {
  const owed = new Set(filings.filter(isOwed).map((filing) => filing.regime_key));
  const tabs = new Map<string, RegimeTab>();
  // A regimes read that has not answered (or failed) leaves the tabs the filings themselves name:
  // every filing stays reachable, and no regime is invented.
  for (const regime of regimes ?? []) tabs.set(regime.key, { key: regime.key, label: regime.label });
  for (const filing of filings) {
    if (!tabs.has(filing.regime_key)) {
      tabs.set(filing.regime_key, { key: filing.regime_key, label: filing.regime_name });
    }
  }
  return [...tabs.values()].sort(
    (a, b) =>
      Number(owed.has(b.key)) - Number(owed.has(a.key)) || a.label.localeCompare(b.label),
  );
}
